import { render } from "./BaseContainer.vue?vue&type=template&id=343aefcd&scoped=true"
const script = {}

import "./BaseContainer.vue?vue&type=style&index=0&id=343aefcd&scoped=true&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\music_player\\music_player_sj\\music_player\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343aefcd"]])

export default __exports__